import { render, staticRenderFns } from "./TemplateStatsPopover.vue?vue&type=template&id=7883c407"
import script from "./TemplateStatsPopover.vue?vue&type=script&lang=js"
export * from "./TemplateStatsPopover.vue?vue&type=script&lang=js"
import style0 from "./TemplateStatsPopover.vue?vue&type=style&index=0&id=7883c407&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports